import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';

import { type LayoutMigration } from '../../../services/compat/migrations/layout-migration.models';

export const drawerV2Migration: LayoutMigration = {
  mode: 'layout',
  description: 'Migrate drawer element to v2',
  run: (element: CanvasElementFrom<'drawer'>): void => {
    if (!('props' in element)) {
      (element as CanvasElementFrom<'drawer'>).props = {} as any;
    }
  },
};
